// extracted by mini-css-extract-plugin
module.exports = {"breadcrumb":"Breadcrumb_breadcrumb__Fonir","link":"Breadcrumb_link__VP_Re","item":"Breadcrumb_item__BGLTW"};